import Toast from 'bootstrap/js/dist/toast';
import Modal from 'bootstrap/js/dist/modal';

export default (context, inject) => {
   inject('getCollectToast', ref => new Toast(ref, {backdrop: 'static'}));
   inject('getAlertModalDefault', ref => new Modal(ref));
}